import { Stack, Text } from "@certn/cascadia";
import { Checkbox, Divider } from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { BrandAssetUploadSection } from "./BrandAssetUploadSection";
import { useBrandingContext } from "../BrandingContext";

export function BrandingUploadSection() {
  const { t } = useTranslation();
  const { whitelabelReport, setWhitelabelReport, isWhitelabelDisabled } =
    useBrandingContext();

  return (
    <Stack>
      <Text style="global/heading-medium">{t("Email & desktop menu")}</Text>
      <BrandAssetUploadSection
        uploadKey="org_logo_url"
        label={<Trans>Logo</Trans>}
        uploadTestId="branding-logo-upload"
        removeTestId="branding-logo-remove"
      />
      <BrandAssetUploadSection
        uploadKey="org_logo_url_dark_mode"
        label={<Trans>Dark mode logo</Trans>}
        uploadTestId="branding-dark-mode-logo-upload"
        removeTestId="branding-dark-mode-logo-remove"
      />
      <Text style="global/body-secondary">
        {t(
          "We recommend a display size of 480 x 160 pixels (3:1 aspect ratio)."
        )}
      </Text>
      <Checkbox
        testID="whitelabel-report"
        isSelected={whitelabelReport}
        isDisabled={isWhitelabelDisabled}
        onChange={setWhitelabelReport}
        description={t(
          "Show your company logo on all PDF reports in place of the Certn logo. Your team and applicants will see your branding on the returned case reports."
        )}
      >
        <Trans>Use my branding on reports</Trans>
      </Checkbox>
      <Divider />
      <Text style="global/heading-medium">{t("Mobile menu & favicon")}</Text>
      <BrandAssetUploadSection
        uploadKey="org_icon_url"
        label={<Trans>Icon</Trans>}
        uploadTestId="branding-icon-upload"
        removeTestId="branding-icon-remove"
      />
      <BrandAssetUploadSection
        uploadKey="org_icon_url_dark_mode"
        label={<Trans>Icon dark mode</Trans>}
        uploadTestId="branding-icon-dark-mode-upload"
        removeTestId="branding-icon-dark-mode-remove"
      />
      <Text style="global/body-secondary">
        {t("We recommend a display size of 30 x 30 pixels (1:1 aspect ratio).")}
      </Text>
    </Stack>
  );
}
